import { inject} from 'inversify-props'
import { FornecedorServiceAdapter } from './adapter/FornecedorServiceAdapter'

export class DeleteFornecedorUseCase {
	@inject('FornecedorServiceAdapter')
	private fornecedorServiceAdapter!: FornecedorServiceAdapter

	delete = async (id: string): Promise<void> =>
		await this.fornecedorServiceAdapter.remove(id)
}